import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { selectIsDarkMode } from 'src/state/theme.selectors';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  temperature: string = '27°C';
  weatherDescription: string = 'Few clouds';
  weatherIcon: string = `${environment.cdnBaseURL}public/icons/01d.png`;
  isScrolled: boolean = false;
  isMenuOpen: boolean = false;

  private themeSubscription: Subscription;
  private isDarkMode: boolean = false;
  private currentIconCode: string = '01d'; // Store the icon code separately
  private langChangeSubscription: Subscription | undefined;

  constructor(private productService: ProductService, private store: Store, private translate: TranslateService) {
    this.themeSubscription = this.store.select(selectIsDarkMode).subscribe((isDark: any) => {
      this.isDarkMode = isDark;
      this.updateWeatherIcon();
    });
  }

  ngOnInit(): void {
    this.loadWeatherData();
    this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {});
  }

  private updateWeatherIcon(): void {
    if (this.isScrolled) {
      this.weatherIcon = `${environment.cdnBaseURL}public/icons/${this.currentIconCode}.png`;
    } else {
      this.weatherIcon = !this.isDarkMode
        ? `${environment.cdnBaseURL}public/icons/${this.currentIconCode}-light.png`
        : `${environment.cdnBaseURL}public/icons/${this.currentIconCode}.png`;
    }
  }

  loadWeatherData(): void {
    this.productService.getPosition().then(
      (pos) => {
        if (pos.lng != null && pos.lat != null) {
          this.productService.getopenweathermaptmpc(pos.lat, pos.lng).then(
            (data) => {
              if (data) {
                this.temperature = Math.ceil(data.main.temp) + '°C';
                this.weatherDescription = data.weather[0].description;
                this.currentIconCode = data.weather[0].icon;
                this.updateWeatherIcon();
              }
            },
            (error) => {
              console.error('Error fetching weather:', error);
            }
          );
        }
      },
      (error) => {
        console.error('Error getting position:', error);
      }
    );
  }

  get translatedWeatherDescription(): string {
    if (!this.weatherDescription) return '';
    const key = `WEATHER.${this.weatherDescription}`;
    const translated = this.translate.instant(key);
    // ngx-translate returns the key itself when no match is found
    return translated === key ? this.weatherDescription : translated;
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const previousScrollState = this.isScrolled;
    this.isScrolled = window.pageYOffset > 50;

    if (previousScrollState !== this.isScrolled) {
      this.updateWeatherIcon();
    }
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
    if (this.isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    document.body.style.overflow = 'unset';
  }

  ngOnDestroy(): void {
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
}
